import { createContext } from 'react';
import { ScreenContextType } from 'types/system/systemType';

const ScreenContext = createContext<ScreenContextType>({
  title: '',
  screenId: '',
  currentMenu: '',
  disableContents: false,
  initializeState: false,
});
export default ScreenContext;
